import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { t } from 'Src/i18n';
import { formatApiDate } from 'Utils/date/apiDate';
type HeaderCriteriaDatesPropsType = {
  selectedProposal: Proposal;
};
export const HeaderCriteriaDates = ({ selectedProposal }: HeaderCriteriaDatesPropsType) => {
  const CONDENSED_DATE_FORMAT = t('booking.common.condensedDateFormat');
  const dates = {
    endDate: formatApiDate(selectedProposal.departureDate, CONDENSED_DATE_FORMAT),
    startDate: formatApiDate(selectedProposal.arrivalDate, CONDENSED_DATE_FORMAT),
  };
  return (
    <span
      className="flex min-w-100 max-w-100 flex-1 items-center justify-center gap-10 rounded-8 border-1 border-solid border-white p-10 text-12 text-white sm:flex-none md:max-w-none"
      data-testid="edit-my-criteria-when"
    >
      <Icon name={ICONS.DATE} width="1.25rem" />
      <span className="block font-bold" data-testid="HeaderCriteriaDates-dates">
        <span className="block leading-1">{dates.startDate}</span>
        <span className="block leading-1">{dates.endDate}</span>
      </span>
    </span>
  );
};
